import { STORE_ID, TYPES } from "./types"

const INITIAL_STATE = {
    item: {
        descricao: "",
        bancoId: "0",
        statusRcId: "0",
        id: ""
    },
    copy: {},
    invalid: {
        descricao: false,
        bancoId: false,
        statusRcId: false
    },
    items: [],
    bancos: [],
    statusRcAll: [],
    activeTab: "Search",
    seeRegister: false,
    permitions: {
        criar: false,
        deletar: false,
    }
}

export default function statusInstituicao(state = INITIAL_STATE, action) {
    switch (action.storeId) {
        case STORE_ID:
            switch (action.type) {
                case TYPES.SET_PERMITIONS:
                    return { ...state, permitions: action.value }
                case TYPES.SET_STATUS_RC_ALL:
                    return { ...state, statusRcAll: action.value }
                case TYPES.SET_BANCOS:
                    return { ...state, bancos: action.value }
                case TYPES.STATUS_INST:
                    return { ...state, items: action.value }
                case TYPES.STATUS:
                    return { ...state, item: action.value }
                case TYPES.INVALID_STATUS:
                    return { ...state, invalid: { ...state.invalid, [action.field]: true } }
                case TYPES.CLEAN_INVALID_STATUS:
                    return { ...state, invalid: { ...state.invalid, [action.field]: false } }
                case TYPES.STATUS_COPY:
                    return { ...state, copy: action.value }
                case TYPES.CLEAN_REGISTER:
                    return { ...state, item: INITIAL_STATE.item, invalid: INITIAL_STATE.invalid }
                case TYPES.SET_ACTIVE_TAB:
                    return { ...state, activeTab: action.value }
                case TYPES.SET_SEE:
                    return { ...state, seeRegister: action.value }
                default:
                    return { ...state }
            }
        default:
            return { ...state }
    }
}